import { gql } from '@apollo/client'

export const GET_EMPLOYMENT_EXPERIENCE = gql`
  query GetEmploymentExperience($employmentExperienceId: String!) {
    employmentExperience(employmentExperienceId: $employmentExperienceId) {
      employmentExperienceId
      createdAt
      updatedAt
      startDate
      endDate
      companyName
      dotNumber
      position
      reasonForLeaving
      contactName
      phone
      faxNumber
      suppressedContactTypes
      email
      equipmentTypes
      address {
        addressId
        street
        city
        state
        zipCode
        country
        startDate
        endDate
      }
      isDriverTerminated
      isDriverSubjectToFMCSRs
      isJobDesignatedAsSafetySensitiveFunctionUnderDOT
      shouldContactEmployer
      isUnemployment
      unemploymentReason
      application {
        applicationId
        applicant {
          applicantId
        }
      }
      verificationOfEmployment {
        voeId
        status
      }
    }
  }
`

export const GET_EMPLOYMENT_EXPERIENCES_BY_APPLICATION_ID = gql`
  query GetEmploymentExperiencesByApplicationId($applicationId: String!) {
    employmentExperiences(applicationId: $applicationId) {
      employmentExperienceId
      createdAt
      updatedAt
      startDate
      endDate
      companyName
      dotNumber
      position
      reasonForLeaving
      contactName
      phone
      faxNumber
      email
      equipmentTypes
      address {
        addressId
        street
        city
        state
        zipCode
        country
        startDate
        endDate
      }
      isDriverTerminated
      isDriverSubjectToFMCSRs
      isJobDesignatedAsSafetySensitiveFunctionUnderDOT
      shouldContactEmployer
      isUnemployment
      unemploymentReason
      carrierContactCount
      suppressedContactTypes
    }
  }
`

export const CREATE_EMPLOYMENT_EXPERIENCE = gql`
  mutation CreateEmploymentExperience(
    $applicationId: String!
    $input: EmploymentExperienceInput!
  ) {
    createEmploymentExperience(applicationId: $applicationId, input: $input) {
      employmentExperienceId
      createdAt
      updatedAt
      startDate
      endDate
      companyName
      dotNumber
      position
      reasonForLeaving
      contactName
      phone
      faxNumber
      email
      equipmentTypes
      address {
        addressId
        street
        city
        state
        zipCode
        country
        startDate
        endDate
      }
      isDriverTerminated
      isDriverSubjectToFMCSRs
      isJobDesignatedAsSafetySensitiveFunctionUnderDOT
      shouldContactEmployer
      isUnemployment
      unemploymentReason
      application {
        applicationId
        applicant {
          applicantId
        }
      }
    }
  }
`

export const UPDATE_EMPLOYMENT_EXPERIENCE = gql`
  mutation UpdateEmploymentExperience(
    $employmentExperienceId: String!
    $input: EmploymentExperienceInput!
  ) {
    updateEmploymentExperience(
      employmentExperienceId: $employmentExperienceId
      input: $input
    ) {
      employmentExperienceId
      createdAt
      updatedAt
      startDate
      endDate
      companyName
      dotNumber
      position
      reasonForLeaving
      contactName
      phone
      faxNumber
      email
      equipmentTypes
      address {
        addressId
        street
        city
        state
        zipCode
        country
        startDate
        endDate
      }
      isDriverTerminated
      isDriverSubjectToFMCSRs
      isJobDesignatedAsSafetySensitiveFunctionUnderDOT
      shouldContactEmployer
      isUnemployment
      unemploymentReason
    }
  }
`

export const DELETE_EMPLOYMENT_EXPERIENCE = gql`
  mutation DeleteEmploymentExperience($employmentExperienceId: String!) {
    deleteEmploymentExperience(
      employmentExperienceId: $employmentExperienceId
    ) {
      employmentExperienceId
      companyName
    }
  }
`
